import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {SDIR_IMAGES} from '../../../../projects/api/src/dataset/dataset.service';
import {CircleMode, CircleSize} from '@inspark/inspark-components/interface';
import {environment} from '../../../environments/environment';

const CIRCLE_MODES: CircleMode[] = ['success', 'warning', 'error', 'falsevalue', 'maintenance', 'none', 'critical', 'primary', 'inverse', 'black'];
const STATE_COLOR_ALIASES: { [k: string]: CircleMode } = { notset: 'none', nocontrol: 'none' };

@Component({
    selector: 'in-state-circle',
    templateUrl: './state-circle.component.html',
    styleUrls: ['./state-circle.component.scss'],
    providers: [],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class StateCircleComponent implements OnChanges, OnInit {


  private _mode: CircleMode = 'none';
  @Input()
  set mode(value: CircleMode) {
    const v = (value ?? '').toString().toLowerCase();
    this._mode = STATE_COLOR_ALIASES[v] ?? (CIRCLE_MODES.includes(v as CircleMode) ? (v as CircleMode) : 'none');
  }
  get mode(): CircleMode {
    return this._mode;
  }
  @Input() size: CircleSize = 'normal';
  @Input() stateId: number;
  @Input() typeId: number;
  @Input() eventsDisabled: boolean;
  @Input() label: string;
  @Input() content: string;
  @Input() black = false;

  icon = '';
  public inIcon = '';

  ngOnInit() {
    this.updateIcon();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.stateId && changes.stateId.previousValue !== changes.stateId.currentValue) {
      this.updateIcon();
    }
  }

  updateIcon() {
    if (this.typeId !== undefined) {
      this.icon = `${environment.backEndUrlPrefix + '/'}db/icon/${this.typeId}/img`;
    } else if (this.stateId !== undefined) {
      if (SDIR_IMAGES[this.stateId]) {
        this.icon = 'scopes/' + SDIR_IMAGES[this.stateId];
      } else {
        this.inIcon = this.eventsDisabled ? 'in-notifications-off' : 'in-notifications';
      }
    } else {
      this.icon = null;
    }
  }
}
